const companyCodes = [
  { label: "EPL", value: "EPL" },
  { label: "ZHL", value: "ZHL" },
  { label: "EBT", value: "EBT" },
  { label: "EMCL", value: "EMCL" },
];

export {companyCodes}